import api from "../api";

export const getBases = (params) =>
  api.get("/base", { params });

export const addBase = (payload) => api.post("/base/add", payload);

export const updateBase = (id, payload) =>
  api.post(`/base/edit/${id}`, payload);

export const deleteBase = (id) =>
  api.post(`/base/delete/${id}`);

export const changeBaseStatus = (id, active) =>
  api.post(`/base/change_status/${id}`, { active });

